import React, { useCallback, useEffect, useState } from 'react'
import {
    AlertType, classBorderLabelDark, classBt, classbtAzul, classbtVerde, classbtVermelho, classInput,
    classInputDark, classLabel, classLabelDark, KEY_CODE_ESCAPE
} from '../../Utils/Types'
import { FeedbackMessage } from '../FeedbackMessage/feedback-message'
import { TbCalendarTime } from 'react-icons/tb'
import { Funcoes } from '../../Utils/Funcoes'
import moment from 'moment'
import { ToolTips } from '../ToolTips/tooltips'
import { FaTrash, FaTrashAlt } from 'react-icons/fa'
import { Tooltip } from 'react-tooltip'
import { MdReceiptLong } from 'react-icons/md'
import { LuFileCheck } from 'react-icons/lu'
import { ModalEditParcelas } from './modal-edit-parcela'
import { RiEdit2Fill } from 'react-icons/ri'
import { ModalEditParcelasCrediario } from './modal-edit-parcela-crediario'

type Props = {
    visible: boolean                                            // responsavel pela vizualização do modal
    valor_venda_crediario?: string
    parcelamento: Parcelamento[]
    setParcelamento: (parcelamento: Parcelamento[]) => void,    // função responsavel por guardar a lista de parcelamento pra ser usado na hora de finalizar a venda
    onClose?: () => void                                        // função para fechar o modal
    onCloseEsc: () => void                                      // função para fechar o modal pelo atalho ESC
}

export type Parcelamento = {
    id: number
    numDup: number
    vencimento: string
    valor: number
    pago: number
}

export const ModalParcelasCrediario = React.memo(({ visible, valor_venda_crediario, parcelamento, setParcelamento, onClose, onCloseEsc }: Props) => {

    // ---------- ATRIBUTOS FEEDBACK -----------------------------------------
    const [visibleMsg, setVisibleMsg] = useState(false)
    const [message, setMessage] = useState("")
    const [messageType, setMessageType] = useState<AlertType>("DANGER")

    // ---------- ATRIBUTOS MANUAL -------------------------------------------
    const [diasParcManual, setDiasParcManual] = useState("")
    const [dataParcManual, setDataParcManual] = useState("")
    const [valorParcManual, setValorParcManual] = useState("")

    // ---------- ATRIBUTOS GERAR PARCELAS -----------------------------------
    let proximoMesIndex = moment().utcOffset('-03:00').add(1, 'month').month()

    const [filterNumParc, setFilterNumParc] = useState('')
    const [mesIniciarParcela, setMesIniciarParcela] = useState(proximoMesIndex.toString())
    const [melhorDia, setMelhorDia] = useState("")

    const [tipoPeriodo, setTipoPeriodo] = useState("Mes")

    // ---------- PARCELAS ---------------------------------------------------
    const [parcelasList, setParcelasList] = useState<Parcelamento[]>([])
    const [valorVenda, setValorVenda] = useState<string>("0.00")
    const [valorLancado, setValorLancado] = useState<string>("0.00")
    const [valorRestante, setValorRestante] = useState<string>("0.00")

    const [dadosParcela, setDadosParcela] = useState<Parcelamento>()
    const [visibleModalEdit, setVisibleModalEdit] = useState(false)

    const handleKeyPressESC = (event: any) => {
        if (event.code === KEY_CODE_ESCAPE && visible && !visibleModalEdit) {

            setParcelamento([])

            onCloseEsc()
            setVisibleMsg(false)
        }
    }

    useEffect(() => {

        let vl_lancado = valorLancado.replaceAll(".", "").replace(",", ".")
        let vl_venda = valorVenda.replaceAll(".", "").replace(",", ".")

        let dValor = parseFloat(vl_venda) - parseFloat(vl_lancado)

        setValorRestante(Funcoes.numberFormat(dValor, 'decimal', 2))
    }, [valorLancado])

    useEffect(() => {

        if (visible) {

            setParcelasList(parcelamento)

            if (valor_venda_crediario) {
                setValorVenda(Funcoes.numberFormat(valor_venda_crediario, 'decimal', 2, 2))
                setValorRestante(Funcoes.numberFormat(valor_venda_crediario, 'decimal', 2, 2))
            }


            let modal = document.getElementById('modal_parcelas_crediario')
            let modalContent = document.getElementById('modal_content_parcelas_crediario')

            if (modal) {
                modal.style.visibility = 'visible'

                if (modalContent) {
                    modalContent.classList.remove('mt-[-1000px]')
                    modalContent.classList.add('mt-14')
                }

                const aguarde = setTimeout(() => {
                    const inputCodBarra = document.getElementById('inputCodBarra')
                    if (inputCodBarra) {
                        inputCodBarra.focus()
                        clearTimeout(aguarde)
                    }
                }, 200)

            }

        } else {

            clearCampos()

            let modal = document.getElementById('modal_parcelas_crediario')
            let modalContent = document.getElementById('modal_content_parcelas_crediario')

            if (modal) {
                modal.style.visibility = 'hidden'

                if (modalContent) {
                    modalContent.classList.add('mt-[-1000px]')
                    modalContent.classList.remove('mt-14')
                }
            }

        }

    }, [visible])

    useEffect(() => {
        document.addEventListener('keydown', handleKeyPressESC)

        return () => {
            document.removeEventListener('keydown', handleKeyPressESC);
        }

    }, [visible, visibleModalEdit])

    useEffect(() => {
        if (diasParcManual) {
            const dias = parseInt(diasParcManual, 10);

            if (!isNaN(dias)) {
                let dataAtual = new Date();

                dataAtual.setDate(dataAtual.getDate() + dias);

                let dataFormatada = dataAtual.toISOString().split('T')[0];

                setDataParcManual(dataFormatada);
            } else {
                setDataParcManual("");
            }
        } else {
            setDataParcManual("");
        }
    }, [diasParcManual]);

    const mesIniciarParcelaChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setMesIniciarParcela(e.target.value)
    }

    const tipoPeriodoChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setTipoPeriodo(e.target.value)
    }

    const handleCloseMessage = () => {
        setVisibleMsg(false)
    }

    const handleClearLancamentosClick = () => {
        setParcelasList([])
        setValorLancado("0,00")
    }

    const clearCampos = () => {
        setDiasParcManual("")
        setDataParcManual("")
        setValorParcManual("")
        setFilterNumParc("1")
        setMelhorDia("")
        setValorVenda("0,00")
        setValorLancado("0,00")
        setValorRestante("0,00")
        setParcelasList([])
    }

    // ------------------------------------------------------ INPUTS DADOS FINANCEIRO ----------------------------------------------
    const handleChangeMelhorDia = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setMelhorDia(e.target.value)
    }

    const valorVendaChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setValorVenda(e.target.value)
    }

    const valorLancadoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setValorLancado(e.target.value)
    }

    const valorRestanteChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setValorRestante(e.target.value)
    }


    // ------------------------------------------------------ FUNÇÕES MODAL EDIÇÃO DE PARCELAS ----------------------------------------------
    const handleDeleteParcel = (parcel: Parcelamento) => {
        const newParcelasList = parcelasList.filter((item) => item.id !== parcel.id)
        setParcelasList(newParcelasList)

        let vl_lancado = valorLancado.replaceAll(".", "").replace(",", ".")

        const dValor = parseFloat(vl_lancado) - parcel.valor
        setValorLancado(Funcoes.numberFormat(dValor, "decimal", 2, 2))

    }

    const handleOpenEditParcel = (parcel: Parcelamento) => {
        setDadosParcela(parcel)
        setVisibleModalEdit(true)
    }

    const handleCloseEditParcel = useCallback(() => {
        setVisibleModalEdit(false)
    }, [])

    const atualizarDadosParcela = useCallback((dados: any) => {
        atualizarParcelaPorNumDup(dados);
        setVisibleModalEdit(false);
    }, [])

    const atualizarParcelaPorNumDup = (novaParcela: { numDup: number; vencimento: string; valor: string }) => {
        setParcelasList(prev => {
            let mudouValor = false;
            let mudouVencimento = false;
            let houveMudanca = false;

            const novaLista = prev.map(parcela => {
                if (parcela.numDup === novaParcela.numDup) {
                    const valorAntigo = Number(parcela.valor);
                    const valorNovo = parseFloat(novaParcela.valor);

                    mudouValor = valorAntigo !== valorNovo;
                    mudouVencimento = parcela.vencimento !== novaParcela.vencimento;
                    houveMudanca = mudouValor || mudouVencimento;

                    if (!houveMudanca) {
                        return parcela; // nada mudou
                    }

                    return {
                        ...parcela,
                        vencimento: novaParcela.vencimento,
                        valor: valorNovo
                    };
                }
                return parcela;
            });

            // se não houve mudança, retorna lista original (sem forçar re-render)
            if (!houveMudanca) {
                return prev;
            }

            // só recalcula totais se mudou o valor
            if (mudouValor) {
                const soma = novaLista.reduce((acc, p) => acc + Number(p.valor), 0);
                setValorLancado(Funcoes.numberFormat(soma, 'decimal', 2));
                setValorRestante(Funcoes.numberFormat((parseFloat(valor_venda_crediario || '0') || 0) - soma, 'decimal', 2));
            }

            return novaLista;
        });
    }

    // ---------------------------------------------------------------- INPUTS LANÇAMENTO MANUAL ----------------------------------------------------------------//
    const diasParcManualChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = e.target;
        // Regex para permitir apenas números
        const numericValue = value.replace(/[^0-9]/g, '');
        setDiasParcManual(numericValue);
    }

    const dataParcManualChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDataParcManual(e.target.value)
    }

    const valorParcManualChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = e.target;
        // Regex para permitir apenas números
        const numericValue = value.replace(/[^0-9]/g, '');
        setValorParcManual(Funcoes.MaskMoney(numericValue));
    }

    const handleLancarParcelaClick = () => {

        setVisibleMsg(false)

        let vl_lancado = valorLancado.replaceAll(".", "").replace(",", ".")
        let vl_venda = valorVenda.replaceAll(".", "").replace(",", ".")

        if (!valorParcManual) {
            const timer = setTimeout(() => {
                setVisibleMsg(true)
                setMessageType("DANGER")
                setMessage("O valor é inválido")
                clearTimeout(timer)
            }, 250)
            return
        }

        if (!dataParcManual) {
            const timer = setTimeout(() => {
                setVisibleMsg(true)
                setMessageType("DANGER")
                setMessage("A data de vencimento é inválida")
                clearTimeout(timer)
            }, 250)
            return
        }

        if (parseFloat(vl_lancado) + parseFloat(valorParcManual) > parseFloat(vl_venda)) {

            setValorParcManual("0.00")

            const timer = setTimeout(() => {
                setVisibleMsg(true)
                setMessageType("DANGER")
                setMessage("A soma das parcelas é maior que o valor do crediário")
                clearTimeout(timer)
            }, 250)
            return
        }

        if (parseFloat(valorParcManual) === 0) {

            const timer = setTimeout(() => {
                setVisibleMsg(true)
                setMessageType("DANGER")
                setMessage("O valor tem que ser maior que zero")
                clearTimeout(timer)
            }, 250)
            return
        }

        let nitem = 1

        nitem = parcelasList.length > 0
            ? Math.max(...parcelasList.map(p => p.id)) + 1
            : 1

        // Cria o novo item de parcelamento
        let itensLista: Parcelamento = {
            id: nitem,
            numDup: nitem,
            vencimento: moment(dataParcManual).format("YYYY-MM-DD"),
            valor: parseFloat(valorParcManual),
            pago: 0,
        }

        // Adiciona o novo item à lista
        let newParcelasList = [...parcelasList, itensLista]
        setParcelasList(newParcelasList)

        // Calcula o novo valor de dias baseado no número atual do item
        let valorDias = parseInt(diasParcManual) * ++nitem

        setDiasParcManual("")
        setValorParcManual("0,00")

        // Atualiza o valor lançado somando com o novo valor da parcela manual
        let valor = parseFloat(vl_lancado) + parseFloat(valorParcManual)
        setValorLancado(Funcoes.numberFormat(valor, 'decimal', 2, 2))
    }

    // ---------------------------------------------------------------- INPUTS GERAR PARCELAR -------------------------------------------------
    const filterNumParcChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        setFilterNumParc(e.target.value.replace(/[^0-9]/g, ''))
    }

    const gerarParcelas = (qtdeParcelas: any) => {
        let parcelasList: Parcelamento[] = [];
        setParcelasList([]);

        if (!mesIniciarParcela) {
            setVisibleMsg(true);
            setMessageType("DANGER");
            setMessage("O mês inicial precisa ser definido");
            return;
        }

        const hoje = moment().format("YYYY-MM-DD");
        const partesData = hoje.split("-");
        const anoAtual = parseInt(partesData[0]);
        const diaAtual = parseInt(partesData[2]);

        let dataInicial = new Date();
        if (mesIniciarParcela) {
            const mesAtual = parseInt(partesData[1]);

            if (parseInt(mesIniciarParcela) < mesAtual) {
                setVisibleMsg(true);
                setMessageType("DANGER");
                setMessage("O mês inicial não pode ser anterior ao mês atual");
                return;
            }

            // ✅ Correção: criar a data com setFullYear para evitar problema de fuso
            dataInicial.setFullYear(anoAtual, parseInt(mesIniciarParcela) - 1, diaAtual);
            dataInicial.setHours(0, 0, 0, 0);
        } else {
            dataInicial = new Date();
            dataInicial.setHours(0, 0, 0, 0);
        }

        // Calcular valores das parcelas
        let vl_venda = valorVenda.replaceAll(".", "").replace(",", ".");
        const valorVendaCentavos = Math.round(parseFloat(vl_venda) * 100);
        const valorParcelaBase = Math.floor(valorVendaCentavos / qtdeParcelas);
        const resto = valorVendaCentavos % qtdeParcelas;

        let totLancadoCentavos = 0;

        for (let i = 0; i < qtdeParcelas; i++) {
            let dataParcela = new Date(dataInicial);

            if (tipoPeriodo === "Mes") {
                // Avança meses
                dataParcela.setMonth(dataInicial.getMonth() + i);

                let vencimento = dataParcela.toISOString().split("T")[0];

                if (melhorDia) {
                    // Ajusta para o melhor dia do mês
                    const ano = dataParcela.getFullYear();
                    const mes = dataParcela.getMonth() + 1;
                    const ultimoDiaMes = Funcoes.GetUltDiaMes(mes, ano);
                    const dia = Math.min(parseInt(melhorDia), ultimoDiaMes);
                    vencimento = `${ano}-${String(mes).padStart(2, "0")}-${String(dia).padStart(2, "0")}`;
                }

                const valorParcela = i < resto ? valorParcelaBase + 1 : valorParcelaBase;
                totLancadoCentavos += valorParcela;

                parcelasList.push({
                    id: i + 1,
                    numDup: i + 1,
                    vencimento,
                    valor: valorParcela / 100,
                    pago: 0,
                });
            } else if (tipoPeriodo === "Semana") {
                // Avança semanas
                dataParcela.setDate(dataInicial.getDate() + i * 7);

                if (melhorDia) {
                    const diasSemana = ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"];
                    const idxSemana = diasSemana.findIndex(d => d.toLowerCase() === melhorDia.toLowerCase());
                    if (idxSemana >= 0) {
                        // Ajustar para o próximo dia da semana desejado
                        while (dataParcela.getDay() !== idxSemana) {
                            dataParcela.setDate(dataParcela.getDate() + 1);
                        }
                    }
                }

                const vencimento = dataParcela.toISOString().split("T")[0];
                const valorParcela = i < resto ? valorParcelaBase + 1 : valorParcelaBase;
                totLancadoCentavos += valorParcela;

                parcelasList.push({
                    id: i + 1,
                    numDup: i + 1,
                    vencimento,
                    valor: valorParcela / 100,
                    pago: 0,
                });
            }
        }

        setParcelasList(parcelasList);
        let valor = Funcoes.MaskMoney(totLancadoCentavos.toString());
        setValorLancado(Funcoes.numberFormat(valor, "decimal", 2, 2));
    }

    const handleConfirmaParcelamentoClick = () => {

        setVisibleMsg(false)


        let vl_restante = valorRestante.replaceAll(".", "").replace(",", ".")

        if (parcelasList.length === 0) {

            const timer = setTimeout(() => {
                setVisibleMsg(true)
                setMessageType("DANGER")
                setMessage("Nenhuma parcela foi lançada")
                clearTimeout(timer)
            }, 250)
            return
        }

        if (parseFloat(vl_restante) !== 0) {

            const timer = setTimeout(() => {
                setVisibleMsg(true)
                setMessageType("DANGER")
                setMessage("Valor(es) da(s) parcela(s) inválido(s)")
                clearTimeout(timer)
            }, 250)
            return
        }

        setParcelamento(parcelasList)

        const timer = setTimeout(() => {
            setVisibleMsg(true)
            setMessageType("SUCCESS")
            setMessage("Parcelas lançadas com sucesso!")
            clearTimeout(timer)
        }, 250)

        if (onClose) {
            onClose()
        }

        setVisibleMsg(false)
        setMelhorDia("")
        setDataParcManual("")
        setFilterNumParc("")

    }

    return (

        <div id="modal_parcelas_crediario" style={{ visibility: "hidden", backgroundColor: 'rgba(0,0,0, 0.6)' }} className={`flex justify-center fixed left-0 right-0 top-0 bottom-0 transition-all duration-300 z-40 `}>

            <div id="modal_content_parcelas_crediario" className={`w-[90%] xl:w-[70%] 2xl:w-[60%] h-full max-h-[550px] bg-white dark:bg-slate-600 rounded-lg mt-[-1000px] transition-all duration-300`}>

                <FeedbackMessage visible={visibleMsg} message={message} type={messageType} onCloseMessage={handleCloseMessage} />

                {/* Header */}
                <div className={`flex items-center w-full h-[60px] border border-x-0 border-t-0 border-b-gray-300 dark:border-b-slate-700`}>

                    <div className={`ml-4 flex items-center justify-center h-10 w-10 rounded-full bg-slate-100 dark:bg-slate-500 border border-slate-300 dark:border-slate-700 shadow-sm shadow-slate-500 dark:shadow-slate-800`}>
                        <TbCalendarTime size={20} className={`w-5 h-5 text-slate-700 dark:text-slate-100`} />
                    </div>

                    <span className={`ml-4 text-lg text-slate-700 dark:text-white flex items-center font-semibold`}>Parcelas</span>

                </div>
                {/* Header */}

                <div className={`flex w-full h-auto`}>

                    <div className={`w-[70%] h-auto`}>

                        <div className={`cursor-default p-1 h-auto`}>

                            <div className={`w-full ${parcelasList.length > 8 ? `pr-[8px]` : ``} `}>

                                <ul className={`w-full h-full bg-blue-800 dark:bg-[#3498DB] text-slate-200`}>

                                    <li className={`h-full border-2 border-white dark:border-slate-600`}>

                                        <div className={`w-full flex flex-row h-10 font-mono`}>

                                            <div className={`flex justify-center items-center w-[15%] h-full border border-slate-300  dark:border-slate-700`}>
                                                <span className={`px-2`}>Ações</span>
                                            </div>

                                            <div className={`flex justify-center items-center w-[20%] h-full border border-slate-300  dark:border-slate-700`}>
                                                <span className={`px-2`}>N. Dup</span>
                                            </div>

                                            <div className={`flex items-center w-[25%] h-full border border-slate-300  dark:border-slate-700`}>
                                                <span className={`px-2`}>Vencimento</span>
                                            </div>

                                            <div className={`flex items-center justify-end w-[40%] h-full border border-slate-300  dark:border-slate-700`}>
                                                <span className={`px-2`}>Valor</span>
                                            </div>

                                        </div>

                                    </li>

                                </ul>

                            </div>

                            <div className={`h-auto overflow-auto scrollbar-track-transparent scrollbar-thumb-slate-400 dark:scrollbar-thumb-slate-800 scrollbar-thin dark:scrollbar-thin`}>

                                <div className={`w-full h-[360px] overflow-y-auto text-black dark:text-slate-200`}>

                                    <ul className={`w-full`}>

                                        {parcelasList.length > 0 &&
                                            parcelasList.map((item, index) => {
                                                return (

                                                    <li key={item.id} tabIndex={0} id={`produto-fecharVenda-${index}`} className={`w-full h-auto duration-150 transition-all focus:outline-none border-2 border-white dark:border-slate-600 hover:bg-slate-100 dark:hover:bg-slate-500 cursor-pointer`}>

                                                        <div className={`w-full flex flex-row h-[51px] font-mono`}>

                                                            <div className={`flex justify-center items-center w-[15%] break-all border border-slate-300 dark:border-slate-700 space-x-3`}>


                                                                <button onClick={() => handleOpenEditParcel(item)}
                                                                    data-tooltip-content="Editar" data-tooltip-id={'btn-editar-' + item.id}
                                                                    className={`flex items-center justify-center
                                                                            text-slate-200 transition-all duration-300
                                                                            hover:bg-sky-600 w-[30px] h-[30px] rounded-md 
                                                                            bg-sky-500 `} >
                                                                    <RiEdit2Fill size="18px" />
                                                                </button>
                                                                <ToolTips target={'btn-editar-' + item.id} bgColor='rgb(14, 165, 233)' />

                                                                <button onClick={() => handleDeleteParcel(item)}
                                                                    data-tooltip-content="Excluir" data-tooltip-id={'btn-excluir-' + item.id}
                                                                    className={`flex items-center justify-center
                                                                            text-slate-200 transition-all duration-300
                                                                            hover:bg-red-600 w-[30px] h-[30px] rounded-md 
                                                                            bg-red-500`} >
                                                                    <FaTrashAlt size="18px" />
                                                                </button>
                                                                <ToolTips target={'btn-excluir-' + item.id} bgColor='rgb(239, 68, 68)' />

                                                            </div>

                                                            <div className={`flex justify-center items-center w-[20%] break-all border border-slate-300 dark:border-slate-700`}>
                                                                <span className={`px-2`}>{item.numDup}</span>
                                                            </div>

                                                            <div className={`flex items-center w-[25%] break-all border border-slate-300 dark:border-slate-700`}>
                                                                <span className={`px-2`}>{Funcoes.FormatDataPtBr(item.vencimento)}</span>
                                                            </div>

                                                            <div className={`flex items-center justify-end w-[40%] break-all border border-slate-300 dark:border-slate-700`}>
                                                                <span className={`px-2`}>{Funcoes.numberFormat(item.valor, 'currency', 2, 2)}</span>
                                                            </div>

                                                        </div>

                                                    </li>
                                                )
                                            })
                                        }

                                    </ul>

                                </div>

                            </div>

                        </div>

                        <div className={`grid grid-cols-12 gap-3 h-auto pt-[14px] mx-2`}>

                            <div className={`relative col-span-4`}>
                                <input disabled={true} id="valorVendaCrediario" className={`${classInput} ${classInputDark} disabled:bg-gray-100 disabled:cursor-not-allowed`} type="text" placeholder=' ' value={valorVenda} onChange={valorVendaChange} />
                                <label htmlFor="valorVendaCrediario" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Total Venda</label>
                            </div>

                            <div className={`relative col-span-4`}>
                                <input disabled={true} id="valorLancadoCrediario" className={`${classInput} ${classInputDark} disabled:bg-gray-100 disabled:cursor-not-allowed`} type="text" placeholder=' ' value={valorLancado} onChange={valorLancadoChange} />
                                <label htmlFor="valorLancadoCrediario" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Total Lançado</label>
                            </div>

                            <div className={`relative col-span-4`}>
                                <input disabled={true} id="valorRestanteCrediario" className={`${classInput} ${classInputDark} disabled:bg-gray-100 disabled:cursor-not-allowed`} type="text" placeholder=' ' value={valorRestante} onChange={valorRestanteChange} />
                                <label htmlFor="valorRestanteCrediario" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Restante</label>
                            </div>

                        </div>

                    </div>

                    <div className={`relative w-[30%] grid grid-cols-12 gap-3 h-full px-2 mt-2 border border-l-gray-300 dark:border-l-slate-700 border-y-0 border-r-0`}>

                        <div className={`relative col-span-12`}>
                            <span className={`text-[14px] text-[#ACACAC] dark:text-slate-300`}>Lançamento Manual</span>
                        </div>

                        <div className={`relative col-span-12`}>
                            <hr className={`border-0 h-px bg-slate-300 dark:bg-slate-700`} />
                        </div>

                        <div className={`relative col-span-6`}>
                            <input id="diasParcManualCrediario" className={`${classInput} ${classInputDark}`} type="text" placeholder=' ' value={diasParcManual} onChange={diasParcManualChange} />
                            <label htmlFor="diasParcManualCrediario" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Dias</label>
                        </div>

                        <div className={`relative col-span-6`}>
                            <input id="dataParcManualCrediario" className={`${classInput} ${classInputDark} dark:[color-scheme:dark] cursor-not-allowed`} type="date" placeholder=' ' min="1900-01-01" max="9999-12-31" disabled={true} value={dataParcManual} onChange={dataParcManualChange} />
                            <label htmlFor="dataParcManualCrediario" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} `}>Vencimento</label>
                        </div>

                        <div className={`relative col-span-12`}>
                            <input id="valorParcManualCrediario" className={`${classInput} ${classInputDark}`} type="text" placeholder=' ' value={valorParcManual} onChange={valorParcManualChange} />
                            <label htmlFor="valorParcManualCrediario" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Valor</label>
                        </div>

                        <div className={`relative col-span-12`}>
                            <button className={`${classbtAzul} ${classBt} w-full disabled:cursor-not-allowed disabled:opacity-40`} onClick={handleLancarParcelaClick} >
                                Lançar Parcela
                            </button>
                        </div>

                        <div className={`relative col-span-12`}>
                            <span className={`text-[14px] text-[#ACACAC] dark:text-slate-300`}>Gerar Parcelas</span>
                        </div>

                        <div className={`relative col-span-12`}>
                            <hr className={`border-0 h-px bg-slate-300 dark:bg-slate-700`} />
                        </div>

                        <div className={`relative col-span-12`}>
                            <select className={`${classInput} ${classInputDark} `} value={tipoPeriodo} onChange={tipoPeriodoChange}>
                                <option value="Mes">Mês</option>
                                <option value="Semana">Semana</option>
                            </select>
                            <label htmlFor="tipoPeriodoCrediario" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Gerar Parecelas por</label>
                        </div>

                        <div className={`relative col-span-6`}>
                            <input id="filterNumParcCrediario" className={`${classInput} ${classInputDark}`} type="text" inputMode='numeric' placeholder=' ' value={filterNumParc} onChange={filterNumParcChange} />
                            <label htmlFor="filterNumParcCrediario" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Parcelas</label>
                        </div>

                        <div className={`relative col-span-6`}>
                            <select className={`${classInput} ${classInputDark}`} value={mesIniciarParcela} onChange={mesIniciarParcelaChange}>
                                <option value="">Selecione o mês</option>
                                <option value="1">Janeiro</option>
                                <option value="2">Fevereiro</option>
                                <option value="3">Março</option>
                                <option value="4">Abril</option>
                                <option value="5">Maio</option>
                                <option value="6">Junho</option>
                                <option value="7">Julho</option>
                                <option value="8">Agosto</option>
                                <option value="9">Setembro</option>
                                <option value="10">Outubro</option>
                                <option value="11">Novembro</option>
                                <option value="12">Dezembro</option>
                            </select>

                            <label htmlFor="dataGerarParcelasCrediario" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Iniciar em</label>
                        </div>

                        <div className={`relative col-span-12`}>
                            <select className={`${classInput} ${classInputDark}`} value={melhorDia} onChange={handleChangeMelhorDia}>
                                <option value=""></option>
                                {tipoPeriodo === 'Mes' &&
                                    Array.from({ length: 31 }, (_, i) => (
                                        <option key={i + 1} value={(i + 1).toString()}>
                                            {i + 1}
                                        </option>
                                    ))
                                }
                                {tipoPeriodo === 'Semana' &&
                                    ['Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado', 'Domingo'].map(dia => (
                                        <option key={dia} value={dia}>
                                            {dia}
                                        </option>
                                    ))
                                }
                            </select>
                            <label htmlFor="dataGerarParcelasCrediario" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Melhor dia de vencimento</label>
                        </div>

                        <div className={`relative col-span-4`}>
                            <button disabled={parseFloat(valorRestante) === 0} className={`${classbtAzul} ${classBt} w-full disabled:cursor-not-allowed disabled:opacity-40`} onClick={() => gerarParcelas(filterNumParc)} data-tooltip-id={'tooltip-btn-gerarParcelas'} id={'btn-gerarParcelas'}>
                                <MdReceiptLong size={"30px"} />
                            </button>

                            <Tooltip style={{ backgroundColor: 'rgb(52, 152, 219)' }} id={'tooltip-btn-gerarParcelas'} anchorSelect={'#btn-gerarParcelas'} positionStrategy="fixed" place='top' >
                                <span>Gerar Parcelas</span>
                            </Tooltip>

                        </div>

                        <div className={`relative col-span-4`}>
                            <button className={`${classbtVermelho} ${classBt}`} onClick={handleClearLancamentosClick} data-tooltip-id={'tooltip-btn-trash'} id={'btn-trash'}>
                                <FaTrash size={"25px"} />
                            </button>

                            <Tooltip style={{ backgroundColor: 'rgb(231, 76, 60)' }} id={'tooltip-btn-trash'} anchorSelect={'#btn-trash'} positionStrategy="fixed" place='top' >
                                <span>Excluir Lançamentos</span>
                            </Tooltip>
                        </div>

                        <div className={`relative col-span-4`}>
                            <button className={`${classbtVerde} ${classBt}`} onClick={handleConfirmaParcelamentoClick} data-tooltip-id={'tooltip-btn-check'} id={'btn-check'}>
                                <LuFileCheck size={"25px"} />
                            </button>

                            <Tooltip style={{ backgroundColor: 'rgb(22, 163, 74)' }} id={'tooltip-btn-check'} anchorSelect={'#btn-check'} positionStrategy="fixed" place='top' >
                                <span>Confirmar parcelas</span>
                            </Tooltip>

                        </div>

                    </div>

                </div>

                <ModalEditParcelasCrediario
                    visible={visibleModalEdit}
                    dados={dadosParcela}
                    atualizarDadosParcelaCrediario={atualizarDadosParcela}
                    closeModalEvent={handleCloseEditParcel}

                />

            </div>

        </div>
    )
})